import { useColors } from '../../hooks';

const { themeColors } = useColors();

export const themeBorders = {
  doubleLeft: `5.5mm double ${themeColors.mainColors.primaryColor}`,
  standardLeft: `3.5mm solid ${themeColors.mainColors.primaryColor}`,
};
